var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgDeterminateLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 101,
    viewBox: "0 0 94 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10359:22701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3269 79.2632H19.5788L0.324326 98.9706C-0.523681 99.8384 0.388732 101 1.91865 101H92.082C93.5712 101 94.4904 99.8931 93.7243 99.0226L76.3269 79.2632Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 26.2653C75 39.3588 53.0024 81.486 48.7183 89.567C48.4124 90.1443 47.5881 90.1443 47.2817 89.567C42.9971 81.486 21 39.3582 21 26.2653C20.9994 11.7594 33.088 0 47.9997 0C62.9115 0 75 11.7594 75 26.2653Z",
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 26.9564C70 39.0825 48 81 48 81C48 81 26 39.0825 26 26.9564C26 14.8304 35.8499 5 48 5C60.1501 5 70 14.8298 70 26.9564Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M48.1471 5.0498C42.8936 5.0498 38.075 6.88541 34.2864 9.93744C35.4383 9.75242 36.6118 9.63038 37.8163 9.63038C49.998 9.63038 59.8735 19.4608 59.8735 31.5868C59.8735 39.437 50.6313 59.7687 44.1116 73.1342C46.5014 77.9223 48.1466 81.0497 48.1466 81.0497C48.1466 81.0497 70.2038 39.1328 70.2038 27.0062C70.2038 14.8796 60.3294 5.0498 48.1471 5.0498Z",
    fill: "#34536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 40C55.1797 40 61 34.1797 61 27C61 19.8203 55.1797 14 48 14C40.8203 14 35 19.8203 35 27C35 34.1797 40.8203 40 48 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M48.1354 0C48.0901 0 48.0453 0.0028199 48 0.00338388V89.9864C48.3239 90.0428 48.6725 89.9266 48.8504 89.5893C53.1133 81.5064 75 39.3681 75 26.2719C74.9994 11.7624 62.9719 0 48.1354 0Z",
    fill: "#743C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10359:22701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.0006,
    height: 101.001,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeterminateLocation);
export default __webpack_public_path__ + "static/media/imgDeterminateLocation.f6ff9e20e72629fda7beac427494e963.svg";
export { ForwardRef as ReactComponent };